import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environment';
import { LikeStatus } from '../../../core/models/like-status.model';

@Injectable({
    providedIn: 'root',
})
export class ReplyLikeService {
    constructor(private httpClient: HttpClient) {}

    getLikeStatus(ticketId, replyId, socialMediaSourceId): Observable<LikeStatus> {
        return this.httpClient.get<any>(
            environment.apiInboxUrl +
                'tickets/' +
                ticketId +
                '/replies/' +
                replyId +
                '/likes?socialMediaSourceId=' +
                socialMediaSourceId,
        );
    }

    changeLikeStatus(ticketId, replyId, socialMediaSourceId, isLiked): Observable<LikeStatus> {
        return this.httpClient.patch<any>(
            environment.apiInboxUrl +
                'tickets/' +
                ticketId +
                '/replies/' +
                replyId +
                '/likes?socialMediaSourceId=' +
                socialMediaSourceId +
                '&isLiked=' +
                isLiked,
            null,
        );
    }
}
